import { observer } from "mobx-react-lite";
import { useApp } from "../context";

import unisLogo from "../assets/logo/UNIS.png";
import hbrsLogo from "../assets/logo/HBRS.png";
import openincLogo from "../assets/logo/openinc.png";

import styled from "styled-components";

const Footer = styled.div`
  height: 60px;
  background: white;
  border-top: 1px solid #ebebeb;
  user-select: none;

  overflow: hidden;

  position: relative;

  /* position: fixed;
  bottom: 0;
  left: 0;
  right: 0; */

  z-index: 3;
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const LogoLink = styled.a`
  display: flex;

  justify-content: center;
  align-items: center;

  height: 59px;
  line-height: 39px;

  color: #333;
  font-size: 12px;

  text-decoration: none;
  text-transform: uppercase;

  padding: 3px;

  > span {
    display: inline-block;
    height: 39px;
    line-height: 39px;
    vertical-align: top;
  }

  > img {
    display: inline-block;
    max-width: 138px;
    max-height: 30px;
    vertical-align: center;
  }
`;

export const FooterContent = observer(function Navigation() {
  const app = useApp();

  return (
    <>
      <Footer>
        <Container>
          <LogoLink
            href="https://www.uni-siegen.de/"
            title="Zur Startseite von Universität Siegen"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="Universität Siegen"
              src={unisLogo}
            />
          </LogoLink>
          <LogoLink
            href="https://www.h-brs.de/"
            title="Zur Startseite von Hochschule Bonn-Rhein-Sieg"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="Hochschule Bonn-Rhein-Sieg"
              src={hbrsLogo}
            />
          </LogoLink>
          <LogoLink
            href="https://openinc.de/"
            title="Zur Startseite von open.INC GmbH"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="open.INC GmbH"
              src={openincLogo}
            />
          </LogoLink>
        </Container>
      </Footer>
    </>
  );
});
